<template>
	<div class="box">
           <div v-show="centerDialogVisible" class="back-box" @click.stop="keyCancle" >
              

          </div>
         <div class="success-box" v-if="successFlag">
             <div class="suceess-title">
                提交成功
             </div>
             <div class="suceess-detail">
                正在审核您的内容，请耐心等待审核结果
             </div>
             <dir class="success-btns">
                      <button class="success-btn-back" @click="backClick">回到首页</button>
                      
                    <button class="success-btn-agin" @click="doAgain">再发一篇</button>
             </dir>
          
          </div>
          <div class="keyss" v-show="fieldFlag">
                    领域：
                    <select class="field-s" v-model="requestData.mainType">
                        <option v-for="(item,index) in fieldList" :key="index">{{item}}</option>
                    </select>
                    <div>
                        <button class="sure-btn" @click="fieldSure">确 定</button>
                    </div>
          </div>
           <div class="keyss" v-show="keyFlag" style="padding-top:0.8rem;width:90%">
                <input class="key-input" type="text" v-model="requestData.keywordsStr" placeholder="请输入关键字">
                <button class="sure-btn" @click="keySure">确 定</button>
                <div style="font-size:0.16rem;padding:0.1rem 0;color:#e1e1e1">
                    每个关键词五个以内汉字或三个以内单词，请用英文逗号隔开。
                </div>
                    
          </div>
	      <div class="main-title">
            发表文章
          </div>
    
          <div class="main-con">
                <div class="title-box" style="position:relative;">
                    <input type="text" v-model="requestData.title" placeholder="请输入文章标题" maxlength="30"> 
                    <span class="clear-icon" @click="clearIt">一键清除</span>
                </div>
                <div style="height:9.5rem;text-align:left;position:relative" id="editor">
                
                </div>
                <el-upload
                  class="avatar-uploader"
                  style="display:none"
                  :action="insertImgUrl"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess1"
                  :on-error="handleAvatarErr"
                   :with-credentials="true"
                  :before-upload="beforeAvatarUpload1"  :data="{type:'7'}" accept="image/*"  capture='camera'>
                  <el-button type="primary" size="small" id="imgUp" class="selecter">上传</el-button>
                </el-upload>
    
                
          </div>
          <div class="main-bottom">
              <img class="icons" style="margin-left:-0.2rem" @click="backClick" src="./../assets/img/back-btn.png" alt="">
              <img class="icons" style="margin-left:0.6rem" @click="keyClick"  src="./../assets/img/key.png" alt="">
              <img class="icons margin" @click="coverClick" src="./../assets/img/fengmian.png" alt="">
              <img class="icons" style="margin-right:0.6rem" @click="typesClick" src="./../assets/img/fenlei.png" alt="">
               <img class="icons" @click="submitClick" src="./../assets/img/fasong.png" alt="">
          </div>
          
    <image-cropper ref="imageCropper" :cropperConfig="cropperConfig" :callback="loadImage"></image-cropper>
	</div>
      
	
</template>

<script>
import Quill from 'quill'
import 'quill/dist/quill.snow.css'
import imageCropper from './cropper/imageCropper.vue'
import {getArticleCanPublish,insertImgUrl,originalImageUpload,publishNewArticle} from './../axios/api.js'
import axios from 'axios'
	export default {
        components:{
          imageCropper
        },
		data (){
			return {
                successFlag:false,
                cropperConfig: {
                    width: 1, // 裁剪宽度（比例）
                    height: 0.7, // 裁剪高度（比例）
                    quality: 1, // 图片质量（0~1之间）
                    maxWidth:550 // 导出的图片的最大宽度
                    },
                fieldList: ['请选择','娱乐', '社会', '财经', '军事', '体育', '游戏', '科技', '自然','国内', '国际', '汽车', '教育', '房产', '时尚', '笑话', '历史', '健康', '星座', '家居', '情感', '旅游', '文化', '职场', '法制', '动漫', '育儿', '宠物', '三农' ],
                centerDialogVisible:false,
                keyFlag:false,
                fieldFlag:false,
                   editor:null,
                   keyValue:"",
              requestData:{
                   title:"",//标题
                   mainType:"请选择",//主分类
                   subType:"",//次分类
                   keywordsStr:"",//关键词
                   imgs:[],//封面图片url
                   content:"",//正文内容
                   autocover:"0",//是否自动封面，1 自动封面
                   isoriginal:"0",//是否原创
                   mopwxurl:"",//猫扑小说链接
                   activename:"0",//是否参加活动  1：参加  0： 不参加
                   iscommend:"0",//是否自荐
                   participate:"0",//是否参加码字活动     1：参加  0： 不参加
                   waresinfo:[],//广告信息
              },
              insertImgUrl:"",
              coverImageUpload:""
			}
        },
        created(){
            this.insertImgUrl = insertImgUrl()
            this.coverImageUpload = originalImageUpload()
        },
		mounted(){
            //  let avatar = new Mavatar({
            //     el: '#cropper',
            //     backgroundColor: '#ff6633'
            //   });
             this.initQuill();
             this.getArticleCanPublish();
		},
		methods:{
            loadImage(urlData){
                let bytes=window.atob(urlData.split(',')[1]);        //去掉url的头，并转换为byte  
                //处理异常,将ascii码小于0的转换为大于0  
                let ab = new ArrayBuffer(bytes.length);  
                let ia = new Uint8Array(ab);  
                for (var i = 0; i < bytes.length; i++) {  
                    ia[i] = bytes.charCodeAt(i);  
                }  
                let file =  new Blob( [ab] , {type : 'image/jpeg'});
                let form = new FormData();
                    form.append("file",file);
                    form.append("typeFrom ","cover");
                    form.append("type",file.type);
                    form.append("size",file.size);
                    this.centerDialogVisible = true;
                    axios({
                        data: form,
                        url: this.coverImageUpload,
                        method: "post"
                    }).then( result => {
                        this.centerDialogVisible = false;
                       // this.$layer.close(tishi);
                        let response = result.data;
                        if(response.code == "0"){
                           let url = response.data.src;
                           this.requestData.imgs = [response.data];
                           console.log(this.requestData.imgs)
                            this.$layer.dialog({
                                content:"封面上传成功",
                                time: 2000,
                            })
                        }else{
                            this.$message.error(response.msg);
                        }
                        
                    }).catch(res => {
                       
                    });
            },
          getArticleCanPublish(){
              getArticleCanPublish().then(res =>{
                  if(res.code == "0"){
                       let max = res.data.maxarticles;
                       let used = res.data.articles;
                       if(max - used >= 0){
                            let num = max - used;
                             this.$layer.dialog({
                                content: `您今天还能发${num}篇文章`,
                                time: 3000
                            })
                       }
                   }else{
                     this.$message.error(res.msg);
                   }
              }).catch(err =>{

              });
          },
		  initQuill(){
            this.editor = new Quill('#editor', {
                theme: 'snow',
                placeholder:"请输入内容",
                modules: {
                    toolbar: {
                            container: [
                                ['bold', 'italic', 'underline'],    //加粗，斜体，下划线，删除线
                                [{ 'list': 'ordered'}, { 'list': 'bullet' }],     //列表
                                ['image'],   //上传图片、上传视频
                            ],
                            handlers: {
                                    'image': function (value) {
                                        if (value) { 
                                             //解决浏ios需要点击两次问题
                                            let phone_flag = navigator.userAgent.toLowerCase();
                                            if (phone_flag.search(/iphone/) != -1) {
                                                console.log("iphone")
                                                    document.querySelector('#imgUp').click();
                                                    document.querySelector('#imgUp').click();
                                            } 
                                            else if (phone_flag.search(/android/) != -1) {
                                                 console.log("android")
                                                    document.querySelector('#imgUp').click()
                                                
                                            }
                                         
                                        } else {
                                            this.editor.format('image', false);
                                        }
                                    }
                                }
                    }
                }
            });
            },
            backClick(){
                this.$router.push({path: '/homePage'});
            },
            doAgain(){
               this.successFlag = false;
               this.requestData = {
                   title:"",//标题
                   mainType:"请选择",//主分类
                   subType:"",//次分类
                   keywordsStr:"",//关键词
                   imgs:[],//封面图片url
                   content:"",//正文内容
                   autocover:"0",//是否自动封面，1 自动封面
                   isoriginal:"0",//是否原创
                   mopwxurl:"",//猫扑小说链接
                   activename:"0",//是否参加活动  1：参加  0： 不参加
                   iscommend:"0",//是否自荐
                   participate:"0",//是否参加码字活动     1：参加  0： 不参加
                   waresinfo:[],//广告信息
              };
              this.editor.root.innerHTML = "";
               
            },
            keyClick(){
              this.centerDialogVisible = true;
              this.keyFlag = true; 
            },
            coverClick(){
             this.$refs.imageCropper.checkPhoto();

            },
            typesClick(){
               this.centerDialogVisible = true;
                this.fieldFlag = true;
               
            },
            submitClick(){
                  
                  if(!this.requestData.title || this.requestData.title.length < 5){
                       this.$layer.dialog({
                                content: "请输入5-30字符的标题",
                                time: 2000
                      })
                      return;
                  }
                  if(!this.requestData.keywordsStr){
                       this.$layer.dialog({
                                content: "请输入关键字",
                                time: 2000
                      })
                      return;
                  }
                  if(!this.requestData.mainType || this.requestData.mainType == "请选择"){
                       this.$layer.dialog({
                                content: "请选择发文领域",
                                time: 2000
                      })
                      return;
                  }
                  if(!this.requestData.imgs || this.requestData.imgs.length == 0){
                       this.$layer.dialog({
                                content: "请上传封面",
                                time: 2000
                      })
                      return;
                  }
                    this.requestData.content = this.editor.root.innerHTML;

                  publishNewArticle(this.requestData).then(res =>{
                  if(res.code == "0"){
                      this.successFlag = true;
                   }else{

                      this.$layer.dialog({
                                content: res.msg,
                                time: 2000
                      })
                   }
              }).catch(err =>{

              });
            },
            keyCancle(){
               this.centerDialogVisible = false;
               this.fieldFlag = false;
               this.keyFlag = false;
            },
            fieldSure(){
                if(!this.requestData.mainType || this.requestData.mainType == '请选择'){
                    this.$layer.dialog({
                                content: "请选择发文领域",
                                time: 2000
                   })
                   return;
                }
               this.centerDialogVisible = false;
               this.fieldFlag = false; 
            },
             keySure(){
                 if(!this.requestData.keywordsStr){
                    this.$layer.dialog({
                                content: "请输入关键字",
                                time: 2000
                   })
                   return;
                 }
               this.centerDialogVisible = false;
               this.keyFlag = false;
              // this.requestData.keywordsStr
               
            },
            handleAvatarErr(){
                this.centerDialogVisible = false;
            },
            handleAvatarSuccess1(res, file) {
                this.centerDialogVisible = false;
                if(res.state == 'SUCCESS'){
                    let url = res.url;
                    let imgheight = res.imgheight;
                    let imgmd5 = res.imgmd5;
                    let imgname = res.imgname;
                    let imgsize = res.imgsize;
                    let imgwidth = res.imgwidth;
                    // 获取光标所在位置
                    let length = this.editor.getSelection().index;
                    // 插入图片，res为服务器返回的图片链接地址
                   // this.editor.insertEmbed(length, 'image', url)
                    // 调整光标到最后
                      
                    this.editor.root.innerHTML = this.editor.root.innerHTML + `<img style="width:90%;margin-left:0.2rem" src="${url}" _src="${url}" imgheight="${imgheight}" imgmd5="${imgmd5}" imgwidth="${imgwidth}" imgsize="${imgsize}" imgname="${imgname}" alt="">` 
                    this.editor.focus();
                }else{
                    this.$message.error("图片上传失败");
                }
            
            },
            beforeAvatarUpload1(file) {
                this.centerDialogVisible = true;
            },
           clearIt(){
               this.editor.root.innerHTML = ""
           }
		}
	}
</script>
<style scoped>
.box{
    font-size: 0.32rem;
}
.main-title{
  width:100%;
  border-bottom: 1px solid #e1e1e1;
  height:0.9rem;
  line-height: 0.9rem;
  background: #fff;
  font-size: 0.34rem;
  font-weight: normal;
  color: #333333;
  text-align: center;
  position:fixed;
  top:0rem;
  z-index:8;
}
.main-bottom{
  background: #fff;
  width:100%;
  height:0.9rem;
  position:fixed;
  bottom:0rem;
  border-top: 1px solid #e1e1e1;
  text-align: center;
  padding-top:0.2rem;
}

.main-con{
    margin:1rem 0rem;
     padding:0rem 0.2rem;
}
.title-box{
   margin-bottom:0.1rem;
    
}
.title-box input{
        width:100%;height:0.68rem;border-radius: 0.1rem;font-size: 0.32rem;text-align: center;color:#333333;border:1px solid #bababa;
}
.key-input{
     width:5rem;
     height:0.6rem;
     border-radius: 0.1rem;
     font-size: 0.28rem;
     text-align: left;
     color:#333333;
     border:1px solid #bababa;  
}
.bottom-icon{
        display:block;
        width: 0.5rem;
        height: 0.5rem;
       
        background-size: 0.45rem 0.45rem;
         position: absolute;
          top:  0.2rem;
     
}
.back{
     background: url('./../assets/img/back-btn.png') no-repeat center center;
       
        left: 0.1rem; 
}
.keys{
     background: url('./../assets/img/key.png') no-repeat center center;
        left: 0.8rem; 
}
.cover{
     background: url('./../assets/img/fengmian.png') no-repeat center center;
      left: 1.4rem; 
}
.type{
     background: url('./../assets/img/fenlei.png') no-repeat center center;
}
.icons{
    width:0.5rem;
  
}
.margin{
  margin:0rem 0.6rem;
}
.back-box{
    position:fixed;
    z-index: 9;
    width:100%;
    height:100%;
    background: rgba(96, 98, 102,0.8);
    top:0px;
}
.success-box{
    position:fixed;
    z-index: 10;
    width:100%;
    height:100%;
    background: #fff; 
    top:0px;  
}
.keyss{
     background: #fff; 
     opacity: 1;
     width:80%;
     margin-top:4rem;
     left:50%;
     transform: translateX(-50%);
     height:3rem;
     border-radius: 0.2rem;
     padding-top:1.1rem;
     position: fixed;
     z-index:100
}
.field-s{
    width:2rem;
    height:0.5rem;
    border-radius: 0.05rem;
    font-size: 0.28rem;
}
.sure-btn{
    background: red;
    color: #fff; 
    border-radius: 0.05rem;
    height:0.56rem;
    line-height:0.56rem;
    width:1rem;
    margin-top:0.5rem;
}
.success-btn-back{
   background: #fff;
    color: #333333; 
    border-radius: 0.1rem;
    height:0.8rem;
    line-height:0.8rem;
    width:1rem;
    margin-top:0.5rem;
    width:1.6rem;
    border:1px solid #909399;
}
.success-btn-agin{
    background: red;
    color: #fff; 
    border-radius: 0.1rem;
    height:0.8rem;
    line-height:0.8rem;
    width:1rem;
    margin-top:0.5rem;
    width:1.6rem;
    margin-left:0.5rem;
}
.suceess-title{
    text-align: center;
    margin-top: 3rem;
    font-size: 0.38rem;
}
.suceess-detail{
    text-align: center;
    margin-top: 0.5rem;
    font-size: 0.22rem;
}
.success-btns{
    padding:0;
}
.clear-icon{
    position:absolute;
    top:0px;
    top:0.95rem;
    font-size:0.26rem;
    right:0.1rem;
    display: inline-block;
    border: 1px solid #f56c6c;
    border-radius: 0.2rem;
    padding:0.02rem;
}
.selecter{
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/pages/pageArticle.vue